import React from 'react';
import styled from 'styled-components';
import { utils } from '@enso/components';
import theme from '../../../theme';

const FooterContainer = styled.footer`
  padding: 60px 24px 24px;
  background-color: ${props => props.theme.color.backgroundDark};
  color: ${props => props.theme.color.backgroundWhite};

  @media ${utils.device.laptop} {
    padding: 80px 140px 40px;
  }
`;

const FooterSection = styled.div`
  margin-bottom: 40px;

  @media ${utils.device.laptop} {
    margin-bottom: 0;
    margin-right: 60px;
  }
`;

const AvailableText = styled.p`
  font-family: ${props => props.theme.font.body};
  font-size: 14px;
  color: ${props => props.theme.color.backgroundWhite};
  font-weight: bold;
  margin: 0;
`;

const FooterContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;

  @media ${utils.device.laptop} {
    flex-direction: row;
    align-items: flex-start;
    gap: 60px;
  }
`;

const FooterRightWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 40px;

  @media ${utils.device.laptop} {
    margin-top: 0;
    margin-left: auto;
    align-items: flex-end;
  }
`;

const SectionTitle = styled.h3`
  font-family: ${props => props.theme.font.title};
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 16px;
  color: ${props => props.theme.color.backgroundWhite};
`;

const SectionTitleGray = styled.h3`
  font-family: ${props => props.theme.font.title};
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 16px;
  color: rgba(255, 255, 255, 0.5);
`;

const SectionTitleGrayNormal = styled.h3`
  font-family: ${props => props.theme.font.title};
  font-size: 16px;
  font-weight: normal;
  margin-bottom: 16px;
  color: rgba(255, 255, 255, 0.5);
  white-space: nowrap;
`;

const LinkList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const LinkItem = styled.li`
  margin-bottom: 12px;
`;

const FooterLink = styled.a`
  font-family: ${props => props.theme.font.body};
  font-size: 14px;
  color: ${props => props.theme.color.backgroundWhite};
  text-decoration: none;
  font-weight: bold;
  opacity: 1;
  white-space: nowrap;

  &:hover {
    opacity: 0.8;
  }
`;

const FooterText = styled.span`
  font-family: ${props => props.theme.font.body};
  font-size: 14px;
  color: ${props => props.theme.color.backgroundWhite};
  text-decoration: none;
  font-weight: bold;
  opacity: 1;
  white-space: nowrap;
  cursor: default;
`;

const SocialLink = styled.a`
  font-family: ${props => props.theme.font.body};
  font-size: 14px;
  color: ${props => props.theme.color.backgroundWhite};
  text-decoration: none;
  font-weight: bold;
  opacity: 1;

  &:hover {
    opacity: 0.8;
  }
`;

const SocialText = styled.span`
  font-family: ${props => props.theme.font.body};
  font-size: 14px;
  color: ${props => props.theme.color.backgroundWhite};
  text-decoration: none;
  font-weight: bold;
  opacity: 1;
  cursor: default;
`;

const CopyrightWrapper = styled.div`
  margin-top: 40px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media ${utils.device.laptop} {
    flex-direction: row;
    gap: 40px;
    align-items: flex-start;
  }
`;

const CopyrightLeft = styled.div`
  font-family: ${props => props.theme.font.body};
  font-size: 12px;
  color: ${props => props.theme.color.backgroundWhite};
  opacity: 0.6;
  text-align: left;
  flex: 0 0 auto;

  @media ${utils.device.laptop} {
    flex: 0 0 300px;
  }
`;

const CopyrightRight = styled.div`
  font-family: ${props => props.theme.font.body};
  font-size: 12px;
  color: ${props => props.theme.color.backgroundWhite};
  opacity: 0.6;
  text-align: left;
  flex: 1;

  p {
    margin: 0 0 16px 0;
    line-height: 1.6;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

FooterContainer.defaultProps = { theme };
SectionTitle.defaultProps = { theme };
SectionTitleGray.defaultProps = { theme };
SectionTitleGrayNormal.defaultProps = { theme };
FooterLink.defaultProps = { theme };
FooterText.defaultProps = { theme };
SocialLink.defaultProps = { theme };
SocialText.defaultProps = { theme };
AvailableText.defaultProps = { theme };
CopyrightLeft.defaultProps = { theme };
CopyrightRight.defaultProps = { theme };

const Footer = function() {
  return (
    <FooterContainer>
      <FooterContentWrapper>
        <FooterSection>
          <SectionTitleGray>Enso</SectionTitleGray>
          <LinkList>
            <LinkItem>
              <FooterText>Tarjeta</FooterText>
            </LinkItem>
            <LinkItem>
              <FooterText>Wallet</FooterText>
            </LinkItem>
            <LinkItem>
              <FooterText>Nosotros</FooterText>
            </LinkItem>
            <LinkItem>
              <FooterText>Soporte</FooterText>
            </LinkItem>
            <LinkItem>
              <FooterLink href="/informacion_para_clientes">
                Información Clientes
              </FooterLink>
            </LinkItem>
          </LinkList>
        </FooterSection>
        <FooterSection>
          <SectionTitleGrayNormal>Siguenos</SectionTitleGrayNormal>
          <LinkList>
            <LinkItem>
              <SocialText>Facebook</SocialText>
            </LinkItem>
            <LinkItem>
              <SocialText>Instagram</SocialText>
            </LinkItem>
            <LinkItem>
              <SocialText>LinkedIn</SocialText>
            </LinkItem>
            <LinkItem>
              <SocialText>X-twitter</SocialText>
            </LinkItem>
          </LinkList>
        </FooterSection>
        <FooterSection>
          <SectionTitleGrayNormal>Legales</SectionTitleGrayNormal>
          <LinkList>
            <LinkItem>
              <FooterLink
                href="/files/Aviso de Privacidad2 (1).pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Aviso de privacidad
              </FooterLink>
            </LinkItem>
            <LinkItem>
              <FooterLink
                href="/files/Aviso al p%C3%BAblico revocaci%C3%B3n voluntaria_Final.docx"
                target="_blank"
                rel="noopener noreferrer"
              >
                Aviso al público sobre revocación voluntaria
              </FooterLink>
            </LinkItem>
            <LinkItem>
              <FooterLink
                href="/files/Terminos_Condiciones_UsoENSO.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Términos y condiciones de uso de la plataforma
              </FooterLink>
            </LinkItem>
            <LinkItem>
              <FooterLink href="/riesgosinherentes">
                Riesgos inherentes
              </FooterLink>
            </LinkItem>
            <LinkItem>
              <FooterLink href="/servicio-al-cliente">
                Servicio al cliente
              </FooterLink>
            </LinkItem>
            <LinkItem>
              <FooterLink href="/estados-legales">Estados Legales</FooterLink>
            </LinkItem>
            <LinkItem style={{ paddingLeft: '16px' }}>
              <FooterLink
                href="/files/INFORMACIÓN ENSO 2023.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                &gt; EEFF Dic 2023
              </FooterLink>
            </LinkItem>
            <LinkItem style={{ paddingLeft: '16px' }}>
              <FooterLink
                href="/files/INFORMACIÓN ENSO MAR2024.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                &gt; EEFF Mar 2024
              </FooterLink>
            </LinkItem>
            <LinkItem style={{ paddingLeft: '16px' }}>
              <FooterLink
                href="/files/20240630_ENSOFINVE_EEFF.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                &gt; EEFF JUN 2024
              </FooterLink>
            </LinkItem>
            <LinkItem style={{ paddingLeft: '16px' }}>
              <FooterLink
                href="/files/20240930_ENSOFINVE_EEFF.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                &gt; EEFF SEP 2024
              </FooterLink>
            </LinkItem>
            <LinkItem style={{ paddingLeft: '16px' }}>
              <FooterLink
                href="/files/EDO FINANC ENSO FINVE 2024.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                &gt; EEFF DIC 2024
              </FooterLink>
            </LinkItem>
            <LinkItem style={{ paddingLeft: '16px' }}>
              <FooterLink
                href="/files/20250331_EF_EEFF_VF.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                &gt; EEFF MAR 2025
              </FooterLink>
            </LinkItem>
            <LinkItem style={{ paddingLeft: '16px' }}>
              <FooterLink
                href="/files/20250630_ENSO_Notas EEFF 1.2.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                &gt; EEFF JUN 2025
              </FooterLink>
            </LinkItem>
            <LinkItem style={{ paddingLeft: '16px' }}>
              <FooterLink
                href="/files/ENSO EEFF SEP 2025.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                &gt; EEFF SEP 2025
              </FooterLink>
            </LinkItem>
            <LinkItem style={{ paddingLeft: '16px' }}>
              <FooterLink
                href="/files/20251231_EF_EEFF_.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                &gt; EEFF DIC 2025
              </FooterLink>
            </LinkItem>
            <LinkItem style={{ paddingLeft: '16px' }}>
              <FooterLink
                href="/files/20260331_EF_EEFF.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                &gt; EEFF MAR 2026
              </FooterLink>
            </LinkItem>
            <LinkItem style={{ paddingLeft: '16px' }}>
              <FooterLink
                href="/files/20260630_EF_EEFF.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                &gt; EEFF JUN 2026
              </FooterLink>
            </LinkItem>
            <LinkItem style={{ paddingLeft: '16px' }}>
              <FooterLink
                href="/files/20260930_EF_EEFF.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                &gt; EEFF SEP 2026
              </FooterLink>
            </LinkItem>
            <LinkItem>
              <FooterLink
                href="/files/INFORME ANUAL DEL DIRECTOR GENERAL DE ENSO FINVE (31032025).pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Informe anual del Director General
              </FooterLink>
            </LinkItem>
            <LinkItem>
              <FooterText>Comisionistas</FooterText>
            </LinkItem>
          </LinkList>
        </FooterSection>
        <FooterSection>
          <SectionTitleGrayNormal>
            Información tecnológica
          </SectionTitleGrayNormal>
          <LinkList>
            <LinkItem>
              <FooterLink href="/tips-seguridad">Tips de seguridad</FooterLink>
            </LinkItem>
            <LinkItem>
              <FooterLink href="/avisos-actualizaciones">
                Avisos y actualizaciones
              </FooterLink>
            </LinkItem>
            <LinkItem>
              <FooterText>Política de cookies</FooterText>
            </LinkItem>
          </LinkList>
        </FooterSection>
        <FooterRightWrapper>
          <AvailableText>Disponible en.</AvailableText>
        </FooterRightWrapper>
      </FooterContentWrapper>
      <CopyrightWrapper>
        <CopyrightLeft>
          Enso es una marca comercial de ENSO FINVE, S.A.P.I de C.V, © 2022.
          TODOS LOS DERECHOS RESERVADOS.
        </CopyrightLeft>
        <CopyrightRight>
          <p>
            ENSO FINVE, S.A.P.I de C.V,. INSTITUCIÓN DE FONDOS DE PAGO
            ELECTRÓNICO, se encuentra autorizada, regulada y supervisada por las
            autoridades del sistema financiero Mexicano; asimismo se hace de su
            conocimiento que ni el Gobierno Federal ni las entidades de la
            administración pública paraestatal podrán responsabilizarse o
            garantizar los recursos de los clientes que sean utilizados en las
            Operaciones que celebren con ENSO FINVE, S.A.P.I de C.V,.
            INSTITUCIÓN DE FONDOS DE PAGO ELECTRÓNICO o frente a otros, así como
            tampoco asumir alguna responsabilidad por las obligaciones
            contraídas por ENSO FINVE, S.A.P.I de C.V,. INSTITUCIÓN DE FONDOS DE
            PAGO ELECTRÓNICO o por algún Cliente frente a otro, en virtud de las
            Operaciones que celebren.
          </p>
          <p>
            ENSO FINVE, S.A.P.I de C.V,. INSTITUCIÓN DE FONDOS DE PAGO
            ELECTRÓNICO, Informa a los Usuarios que el Gobierno Federal y las
            Entidades de la Administración Pública Paraestatal no podrán
            responsabilizarse o garantizar los recursos de los Usuarios que sean
            utilizados en las operaciones que celebren con las Instituciones de
            Tecnología Financiera o frente a otros, ni asumir alguna
            responsabilidad por las obligaciones contraídas por las
            Instituciones de Tecnología Financiera o por algún Usuario frente a
            otro, en virtud de las operaciones que celebren.
          </p>
        </CopyrightRight>
      </CopyrightWrapper>
    </FooterContainer>
  );
};

export default Footer;
